module.exports = __webpack_public_path__ + "c497896a6db10ef765cd166730c03faf.pdf";